import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd7bb694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper",
  ref: "horizontalWizardRef"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav py-5 mt-5\" data-v-bd7bb694><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-bd7bb694><h3 class=\"stepper-title\" data-v-bd7bb694>Applicant Details</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-bd7bb694><h3 class=\"stepper-title\" data-v-bd7bb694>Choose Plan</h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-bd7bb694><h3 class=\"stepper-title\" data-v-bd7bb694>Review and Complete</h3></div></div>", 1)
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { "data-kt-stepper-element": "content" }
const _hoisted_7 = { "data-kt-stepper-element": "content" }
const _hoisted_8 = {
  key: 0,
  class: "form-group my-3 mx-auto consent-check"
}
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = {
  class: "form-check-label",
  for: "form-middlenameCheck"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("By agreeing to ")
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(", you are consenting to the collection, storage and processing of the supplied information ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-20" }, null, -1))
const _hoisted_15 = { class: "d-flex flex-stack pt-15" }
const _hoisted_16 = { class: "mr-2" }
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_22 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_24 = {
  key: 1,
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_26 = { class: "svg-icon svg-icon-4 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ConsentModal = _resolveComponent("ConsentModal")!
  const _component_StripeModal = _resolveComponent("StripeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (!_ctx.fetchingResources)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "mx-auto w-100 pt-15 pb-10",
                novalidate: "novalidate",
                id: "kt_create_account_form",
                onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Step1, {
                    "initial-table-data": _ctx.formData.applicants,
                    "active-subscription": _ctx.activeSubscription,
                    "is-subscription-selected": _ctx.useActiveSubscription,
                    "aml-plans": _ctx.amlPlans,
                    onApplicantsUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onApplicantsUpdate($event))),
                    onSubscriptionSelected: _ctx.handleSelectSubscription
                  }, null, 8, ["initial-table-data", "active-subscription", "is-subscription-selected", "aml-plans", "onSubscriptionSelected"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Step2, {
                    plan: _ctx.formData.plan
                  }, null, 8, ["plan"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Step3, {
                    formData: _ctx.formData,
                    plan: _ctx.selectedPlan,
                    fees: _ctx.fees,
                    "total-fees": _ctx.totalFees,
                    "total-price": _ctx.totalPrice,
                    "use-active-subscription": _ctx.useActiveSubscription,
                    "aml-total": _ctx.amlTotal,
                    "billed-amount": _ctx.billedAmount
                  }, null, 8, ["formData", "plan", "fees", "total-fees", "total-price", "use-active-subscription", "aml-total", "billed-amount"])
                ]),
                (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hasAgreed) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.hasAgreed]
                        ]),
                        _createElementVNode("label", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", {
                            class: "text-primary",
                            "data-bs-toggle": "modal",
                            "data-bs-target": `#${_ctx.$modals.CONSENT_MODAL}`
                          }, "our terms", 8, _hoisted_12),
                          _hoisted_13
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-lg btn-light-primary me-3",
                      "data-kt-stepper-action": "previous",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _hoisted_18
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-lg btn-primary me-3",
                          "data-kt-stepper-action": "submit",
                          disabled: !_ctx.hasAgreed,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.formSubmit()))
                        }, [
                          _createElementVNode("span", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                            ])
                          ]),
                          _hoisted_23
                        ], 8, _hoisted_19))
                      : (_openBlock(), _createElementBlock("button", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("span", _hoisted_26, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                  ])
                ])
              ], 32))
            : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
        ], 512)
      ])
    ]),
    _createVNode(_component_ConsentModal),
    _createVNode(_component_StripeModal, {
      "client-secret": _ctx.stripeSecret,
      onSuccess: _ctx.processPayment
    }, null, 8, ["client-secret", "onSuccess"])
  ], 64))
}